<script lang="typescript">
    import Loader from "shared/loader.svelte";
    import Form from "shared/form.svelte";
    import Input from "shared/input.svelte";

    import Switch from "shared/switch.svelte";
    import List from "shared/list.svelte";

    import Sheet from "shared/sheet.svelte";
    import Header from "../components/header.svelte";
    import SectionSubHeader from "../components/section-subheader.svelte";
    import Subtitle2 from "shared/typography/subtitle2.svelte";
    import Caption from "shared/typography/caption.svelte";
    import Button from "shared/button.svelte";
    import DropDown from "shared/dropdown.svelte";

    import TimeLine from "../components/charts/timeline.svelte";
    // remove on production

    import * as ApiService from "../services/api.service";

    let rules: Rule[] = [];
    let jorneys: Journey[] = [];
    let condittions: RuleCondition[] = [];

    let selectedRule: Rule;
    let selectedJourney: Journey;
    let selectedRuleTemp: Rule;
    let selectedOldId: string;
    let inAddingNew = false;

    let inEditMode = false;
    let isFormValid = true;
    let status = "";

    import {
        AnomalyIcon,
        EditIcon,
        EmptyIcon,
        LogoIcon,
        NotificationIcon,
        RemoveIcon,
        RuleIcon,
    } from "../components/icons";
    import { onMount } from "svelte";
    import InputTextarea from "shared/input-textarea.svelte";
    import { ConfirmationDialog } from "./dialogs";
    import { RequiredValidation } from "shared/validations/required";
    import { RegexValidation } from "shared/validations/regex";
    import { RuleUtils, to } from "../utils";
    import { ModalSystem } from "shared/systems";
    import { slide, scale } from "svelte/transition";
    import { selected } from "shared/systems/drawer.system";
    import Expander from "shared/expander.svelte";
    import type { ExternalBar } from "src/components/charts/timeline";

    let isListProcessing = true;
    let isFormProcessing = false;

    let sleep = (delay: number) =>
        new Promise((resolve, _) => {
            setTimeout(resolve, delay);
        });

    const onRuleSelected = (e: any) => {
        const { selected } = e.detail;
        console.log({ selected });

        selectRule(selected as Rule);
    };

    const addNewRule = () => {
        let defaultRule: Rule = {
            id: (+new Date()).toString(),
            title: "",
            description: "",
            device: "Ponto.*",
            condition: "IN_RANGE",
            journeys: [jorneys[0].name],
            notification: {
                email: true,
                whatsapp: false,
                desktop: false,
            },
            recursiveProcess: false,
            startRule: "05:00:00",
            endRule: "06:30:00",
            startProcess: "19:00:00",
            endProcess: "19:20:00",
        };

        rules.push(defaultRule);

        selectRule(defaultRule);

        inAddingNew = true;
        inEditMode = true;
    };

    const editRule = (item: Rule) => {
        console.log("editRule", item);
        selectRule(item);
        // store the selected in a temp variable
        selectedRuleTemp = JSON.parse(JSON.stringify(selectedRule)); //{ ...selectedRule };
        inEditMode = true;
    };

    const editSave = async () => {
        inEditMode = false;
        inAddingNew = false;

        isListProcessing = true;
        status = "Adicionando nova regra...";

        // is new or edit
        let ruleIndex = rules.findIndex((r) => r.id === selectedRule.id);

        // refresh on list
        rules[ruleIndex] = selectedRule;
        rules = [...rules];

        let [errSave, _] = await to(ApiService.saveRules(rules));

        if (errSave) {
            status = "Error ao salvar regra...";
            await sleep(3000);
        }

        await fetchLists();
        selectRule(rules[ruleIndex]);
        await sleep(1000);

        isListProcessing = false;
        status = "";
    };

    const editCancel = () => {
        if (inAddingNew) {
            // remove the new created
            rules = rules.filter((r) => r.id !== selectedRule.id);
        } else {
            rules = rules.map((r) => {
                if (r.id === selectedRuleTemp.id) {
                    return selectedRuleTemp;
                }
                return r;
            });
        }

        if (rules.length === 0) {
            selectRule(undefined);
        } else {
            selectRule(rules[0]);
        }

        inAddingNew = false;
        inEditMode = false;
    };

    const listRemove = async (item: Rule) => {
        const dialogResult = await ModalSystem.show<boolean>({
            component: ConfirmationDialog,
            props: {
                title: `Confirmação de remoção`,
                description: `Tem certeza que deseja remover a regra "${item.title}" ?`,
                okText: "remover",
                cancelText: "cancelar",
            },
            parameters: { size: "small", canClose: true },
        });

        // TODO: add a remove logic
        if (dialogResult == true) {
            isListProcessing = true;
            status = "Removendo item da lista...";
            // filter selected to be removed
            rules = rules.filter((r) => r.id !== selectedRule.id);

            let [errorSave, _] = await to(ApiService.saveRules(rules));

            if (errorSave) {
                status = "Erro ao salvar lista alterada";
                return;
            }

            await sleep(2000);

            if (rules.length > 0) {
                selectRule(rules[0]);
            } else {
                selectRule(undefined);
            }

            isListProcessing = false;
            status = "";
        }
    };

    const onAlgorithmChange = () => {
        if (selectedRule.condition === "COMPOUND_ACCESS") {
            selectedRule.rules = [];
        } else {
            delete (selectedRule as any).rules;
        }

        if (selectedRule.condition === "DEVICE_TOLERANCE") {
            selectedRule.deviceStart = "";
            selectedRule.deviceEnd = "";
            selectedRule.deviceToleranceMinutes = 10;
        } else {
            delete (selectedRule as any).deviceStart;
            delete (selectedRule as any).deviceEnd;
            delete (selectedRule as any).deviceToleranceMinutes;
        }

        if (selectedRule.condition === "JOURNEY_SIZE") {
            selectedRule.journeySize = 480;
        } else {
            delete (selectedRule as any).journeySize;
        }
    };

    const fetchLists = async () => {
        isListProcessing = true;
        status = "Atualizando listas...";

        let [errList, ruleList] = await to(ApiService.getRules());
        if (errList) {
            status = "Erro ao tentar carregar a lista de regras";
            return;
        }
        let [errJorney, jorneyList] = await to(ApiService.getJorneys());
        if (errJorney) {
            status = "Erro ao tentar carregar a lista de jornadas";
            return;
        }
        let [errCond, conditionList] = await to(ApiService.getConditions());
        if (errCond) {
            status = "Erro ao tentar carregar a lista de algorítmos";
            return;
        }

        // TODO: remove on production
        await sleep(1000);

        rules = ruleList;
        jorneys = jorneyList;
        condittions = conditionList.map((c) => {
            c.icon = RuleUtils.getConditionIcon(c.value);
            return c;
        });

        isListProcessing = false;
        status = "";
    };

    const selectRule = (rule: Rule) => {
        if (rule === undefined) {
            selectedRule = undefined;
            selectedJourney = undefined;
            selectedJourney = undefined;
            return;
        }

        selectedRule = rule;
        selectedJourney = jorneys.find(
            (j) => j.name === selectedRule.journeys[0]
        );
    };

    const getVirtualValidation = (rule: Rule): IValidationResult[] => {
        if (rule.condition === "COMPOUND_ACCESS" && rule.rules.length < 2) {
            return [
                {
                    isValid: false,
                    error:
                        "regras compostas precisam de 2 ou mais regras internas",
                },
            ];
        }

        return [];
    };

    const addInternalRule = () => {
        if (selectedRule.condition === "COMPOUND_ACCESS") {
            let newInternalRule: InternalRule = {
                condition: "IN_RANGE",
                description: "Descrição",
                device: "",
                startRule: "07:00:00",
                endRule: "16:45:00",
            };
            selectedRule.rules = [...selectedRule.rules, newInternalRule];
        }
    };

    const removeInternalRule = (index: number) => {
        if (selectedRule.condition === "COMPOUND_ACCESS") {
            selectedRule.rules = selectedRule.rules.filter(
                (_, i) => i !== index
            );
        }
    };

    const onInternalAlgorithmChange = () => {};

    onMount(async () => {
        await fetchLists();

        if (rules && rules.length > 0) {
            selectRule(rules[0]);
        }
    });
</script>

<div class="rules-view">
    <div class="content">
        <Header
            title="Regras"
            subtitle="Configure todas as regras para detectar anomalias no acesso dos funcionários"
        />
        <div class="columns ">
            <!-- List Column -->
            {#if !inEditMode}
                <div class="rows mr-16 list">
                    <SectionSubHeader
                        icon={AnomalyIcon}
                        title="Lista de Regras"
                    />

                    <Sheet>
                        <div class="buttons">
                            {#if isListProcessing}
                                <div class="status">
                                    <Loader size={36} />
                                    <Subtitle2
                                        text={status}
                                        style="padding: 0 16px;"
                                    />
                                </div>
                            {/if}
                            <Button text="nova regra" on:click={addNewRule} />
                        </div>

                        {#if !isListProcessing && !isFormProcessing}
                            <List
                                on:select={onRuleSelected}
                                selected={selectedRule}
                                items={rules}
                            >
                                <div
                                    slot="item"
                                    class="list-item"
                                    let:item
                                    let:active
                                >
                                    <span class="item-icon">
                                        <svelte:component
                                            this={RuleUtils.getConditionIcon(
                                                item.condition
                                            )}
                                            width={24}
                                            height={24}
                                            color="var(--color-level-5)"
                                        />
                                    </span>

                                    <div class="list-info rows">
                                        <Subtitle2
                                            text={item.title}
                                            color={active
                                                ? "var(--color-primary)"
                                                : "var(--color-level-7)"}
                                        />
                                        <Caption
                                            text={item.description}
                                            color="var(--color-level-5)"
                                        />
                                    </div>
                                    <span
                                        class="item-icon"
                                        on:click={() => editRule(item)}
                                    >
                                        <EditIcon
                                            width={24}
                                            height={24}
                                            color="var(--color-level-6)"
                                        />
                                    </span>
                                    <span
                                        class="item-icon"
                                        on:click={() => listRemove(item)}
                                    >
                                        <RemoveIcon
                                            width={24}
                                            height={24}
                                            color="var(--color-level-6)"
                                        />
                                    </span>
                                </div>
                            </List>
                        {/if}
                    </Sheet>
                </div>
            {/if}

            <!-- Edit Column -->
            {#if inEditMode}
                <div class="rows mr-16" in:scale>
                    <SectionSubHeader
                        icon={AnomalyIcon}
                        title="Detalhes da Regra"
                    />

                    <Sheet
                        style=" width:620px; display:flex; flex-direction: column;"
                    >
                        {#if selectedRule}
                            <Form
                                bind:isValid={isFormValid}
                                virtualValidations={getVirtualValidation(
                                    selectedRule
                                )}
                            >
                                <div class="edit-content">
                                    <div class="row">
                                        <Input
                                            width="64px"
                                            name="rule-id"
                                            bind:value={selectedRule.id}
                                            label="Rule Id"
                                            disabled
                                        />
                                        <Input
                                            name="title"
                                            bind:value={selectedRule.title}
                                            label="Título da Regra"
                                            validations={[
                                                RequiredValidation(
                                                    "Este campo não pode ficar em branco"
                                                ),
                                            ]}
                                        />
                                    </div>

                                    <div class="row row-1">
                                        <InputTextarea
                                            width="100%"
                                            name="rule-description"
                                            bind:value={selectedRule.description}
                                            label="Descrição longa da regra"
                                            placeholder="Descrição..."
                                        />
                                    </div>

                                    <div class="row">
                                        <DropDown
                                            name="rule-jorney"
                                            label="Jornada"
                                            items={jorneys}
                                            icon={RuleIcon}
                                            dictionary={{
                                                value: "name",
                                                title: "name",
                                                description: "name",
                                            }}
                                            bind:value={selectedRule
                                                .journeys[0]}
                                            on:change={onAlgorithmChange}
                                        />
                                        <DropDown
                                            name="rule-condition"
                                            label="Algorítmo de Anomalia"
                                            items={condittions}
                                            icon={AnomalyIcon}
                                            dictionary={{
                                                value: "value",
                                                title: "title",
                                                description: "description",
                                                icon: "icon",
                                            }}
                                            bind:value={selectedRule.condition}
                                            on:change={onAlgorithmChange}
                                        />
                                    </div>

                                    <!-- Conditional Fields -->
                                    {#if selectedRule.condition == "DEVICE_TOLERANCE"}
                                        <div class="row row-1">
                                            <Subtitle2
                                                style="white-space: pre-wrap;"
                                                text="O Sistema irá calcular o intervalo de acesso entre dois dispositivos"
                                            />
                                        </div>

                                        <div class="row row-3" transition:slide>
                                            <Input
                                                id="selectedrule.deviceStart"
                                                name="selectedrule.deviceStart"
                                                bind:value={selectedRule.deviceStart}
                                                label="Primeiro Dispositivo"
                                                validations={[
                                                    RequiredValidation(
                                                        "Este campo não pode ficar em branco"
                                                    ),
                                                ]}
                                            />

                                            <Input
                                                id="selectedrule.deviceEnd"
                                                name="selectedrule.deviceEnd"
                                                bind:value={selectedRule.deviceEnd}
                                                label="Segundo Dispositivo"
                                                validations={[
                                                    RequiredValidation(
                                                        "Este campo não pode ficar em branco"
                                                    ),
                                                ]}
                                            />

                                            <Input
                                                id="selectedrule.deviceToleranceMinutes"
                                                name="selectedrule.deviceToleranceMinutes"
                                                bind:value={selectedRule.deviceToleranceMinutes}
                                                type="number"
                                                label="Tolerância (minutos)"
                                                validations={[
                                                    RegexValidation(
                                                        /^[1-9][0-9]*$/,
                                                        "Numeral maior que 0"
                                                    ),
                                                ]}
                                            />
                                        </div>
                                    {/if}

                                    {#if ["DEVICE_TOLERANCE", "COMPOUND_ACCESS"].indexOf(selectedRule.condition) === -1}
                                        <div class="row row-1" transition:slide>
                                            <Input
                                                id="selectedRule.device"
                                                name="selectedRule.device"
                                                bind:value={selectedRule.device}
                                                label="Nome do dispositivo"
                                                validations={[
                                                    RequiredValidation(
                                                        "Este campo não pode ficar em branco"
                                                    ),
                                                ]}
                                            />
                                        </div>
                                    {/if}

                                    {#if selectedRule.condition === "JOURNEY_SIZE"}
                                        <div class="row" transition:slide>
                                            <Input
                                                id="selectedRule.journeySize"
                                                name="selectedRule.journeySize"
                                                bind:value={selectedRule.journeySize}
                                                type="number"
                                                label="Tamanho da jornada (Minutos) "
                                                validations={[
                                                    RegexValidation(
                                                        /^[1-9][0-9]*$/,
                                                        "Numeral maior que 0"
                                                    ),
                                                ]}
                                            />

                                            <Subtitle2
                                                style="white-space: pre-wrap;"
                                                color="var(--color-level-7)"
                                                text="Tamanho da jornada máxima será de {RuleUtils.getJorneySizeHour(
                                                    selectedRule.journeySize
                                                )}"
                                            />
                                        </div>
                                    {/if}

                                    <!------------------------------------>

                                    <!-- Compound Access -->
                                    {#if selectedRule.condition === "COMPOUND_ACCESS"}
                                        <div class="row row-1" transition:slide>
                                            <div class="buttons">
                                                <Button
                                                    text="adicionar regra"
                                                    on:click={addInternalRule}
                                                />
                                            </div>
                                        </div>
                                    {/if}

                                    {#if selectedRule.condition === "COMPOUND_ACCESS"}
                                        <div class="row row-1">
                                            <Subtitle2
                                                style="white-space: pre-wrap; "
                                                color="var(--color-level-8)"
                                                text="Regras"
                                            />
                                        </div>
                                        {#each selectedRule.rules as rule, ruleIndex}
                                            <Expander
                                                header={RuleUtils.getConditionName(
                                                    rule.condition,
                                                    condittions
                                                )}
                                                color={RuleUtils.getConditionColor(
                                                    rule.condition
                                                )}
                                                style="margin-bottom: 8px;"
                                                mode="hide"
                                            >
                                                <Sheet
                                                    style="padding: 16px; margin-bottom:16px;"
                                                >
                                                    <div class="row row-2">
                                                        <InputTextarea
                                                            id="rule.description.{ruleIndex}"
                                                            width="100%"
                                                            name="rule-description"
                                                            bind:value={rule.description}
                                                            label="Descrição longa da regra"
                                                            placeholder="Descrição..."
                                                        />
                                                        <DropDown
                                                            name="rule-condition"
                                                            label="Algorítmo de Anomalia"
                                                            items={condittions.filter(
                                                                (c) =>
                                                                    c.value !==
                                                                    "COMPOUND_ACCESS"
                                                            )}
                                                            icon={AnomalyIcon}
                                                            dictionary={{
                                                                value: "value",
                                                                title: "title",
                                                                description:
                                                                    "description",
                                                            }}
                                                            bind:value={rule.condition}
                                                            on:change={onInternalAlgorithmChange}
                                                        />
                                                    </div>

                                                    <div class="row row-2">
                                                        <Input
                                                            id="rule.startRule.{ruleIndex}"
                                                            name="rule.startRule"
                                                            bind:value={rule.startRule}
                                                            label="Início da Verificação"
                                                            validations={[
                                                                RegexValidation(
                                                                    /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
                                                                    "Formato correto: 23:59:00"
                                                                ),
                                                            ]}
                                                        />
                                                        <Input
                                                            id="rule.endRule.{ruleIndex}"
                                                            name="rule.endRule"
                                                            bind:value={rule.endRule}
                                                            validations={[
                                                                RegexValidation(
                                                                    /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
                                                                    "Formato correto: 23:59:00"
                                                                ),
                                                            ]}
                                                            label="Fim da Verificação"
                                                        />
                                                    </div>

                                                    <!--  ONy rules tolerance, range and odd access have device field -->
                                                    {#if rule.condition !== "DEVICE_TOLERANCE"}
                                                        <div class="row row-2">
                                                            <Input
                                                                id="rule.device.{ruleIndex}"
                                                                name="rule.device.{ruleIndex}"
                                                                bind:value={rule.device}
                                                                label="Nome do dispositivo"
                                                                validations={[
                                                                    RequiredValidation(
                                                                        "Este campo não pode ficar em branco"
                                                                    ),
                                                                ]}
                                                            />
                                                        </div>
                                                    {/if}

                                                    <!--  Specified fields for each rule -->
                                                    {#if rule.condition === "DEVICE_TOLERANCE"}
                                                        <div class="row row-3">
                                                            <Input
                                                                id="rule.deviceStart{ruleIndex}"
                                                                name="rule.deviceStart.{ruleIndex}"
                                                                bind:value={rule.deviceStart}
                                                                label="Primeiro dispositivo"
                                                                validations={[
                                                                    RequiredValidation(
                                                                        "Este campo não pode ficar em branco"
                                                                    ),
                                                                ]}
                                                            />

                                                            <Input
                                                                id="rule.deviceEnd.{ruleIndex}"
                                                                name="rule.deviceEnd.{ruleIndex}"
                                                                bind:value={rule.deviceEnd}
                                                                label="Último dispositivo"
                                                                validations={[
                                                                    RequiredValidation(
                                                                        "Este campo não pode ficar em branco"
                                                                    ),
                                                                ]}
                                                            />

                                                            <Input
                                                                id="rule.deviceToleranceMinutes.{ruleIndex}"
                                                                name="rule.deviceToleranceMinutes.{ruleIndex}"
                                                                bind:value={rule.deviceToleranceMinutes}
                                                                type="number"
                                                                label="Tolerância (minutos)"
                                                                validations={[
                                                                    RegexValidation(
                                                                        /^[1-9][0-9]*$/,
                                                                        "Numeral maior que 0"
                                                                    ),
                                                                ]}
                                                            />
                                                        </div>
                                                    {/if}

                                                    {#if rule.condition === "JOURNEY_SIZE"}
                                                        <div class="row">
                                                            <Input
                                                                id="rule.journeySize.{ruleIndex}"
                                                                name="rule.journeySize.{ruleIndex}"
                                                                bind:value={rule.journeySize}
                                                                type="number"
                                                                label="Tamanho da jornada (Minutos)"
                                                                validations={[
                                                                    RegexValidation(
                                                                        /^[1-9][0-9]*$/,
                                                                        "Numeral maior que 0"
                                                                    ),
                                                                ]}
                                                            />

                                                            <Subtitle2
                                                                style="white-space: pre-wrap;"
                                                                color="var(--color-level-7)"
                                                                text="Tamanho da jornada máxima será de {RuleUtils.getJorneySizeHour(
                                                                    rule.journeySize
                                                                )}"
                                                            />
                                                        </div>
                                                    {/if}

                                                    <div
                                                        class="row row-1"
                                                        transition:slide
                                                    >
                                                        <div
                                                            class="buttons"
                                                            style="background: transparent;"
                                                        >
                                                            <Button
                                                                text="remover"
                                                                on:click={() =>
                                                                    removeInternalRule(
                                                                        ruleIndex
                                                                    )}
                                                            />
                                                        </div>
                                                    </div>
                                                </Sheet>
                                            </Expander>
                                        {/each}

                                        <div
                                            class="row row-1"
                                            style="margin-bottom:16px;"
                                        />
                                    {/if}

                                    <!------------------------------------>

                                    <div class="row row-4">
                                        <Input
                                            name="rule-start"
                                            bind:value={selectedRule.startRule}
                                            label="Início da Verificação"
                                            validations={[
                                                RegexValidation(
                                                    /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
                                                    "Formato correto: 23:59:00"
                                                ),
                                            ]}
                                        />
                                        <Input
                                            name="rule-end"
                                            bind:value={selectedRule.endRule}
                                            validations={[
                                                RegexValidation(
                                                    /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
                                                    "Formato correto: 23:59:00"
                                                ),
                                            ]}
                                            label="Fim da Verificação"
                                        />

                                        <Input
                                            name="rule-startProcess"
                                            bind:value={selectedRule.startProcess}
                                            validations={[
                                                RegexValidation(
                                                    /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
                                                    "Formato correto: 23:59:00"
                                                ),
                                            ]}
                                            label="Início do Envio"
                                        />

                                        <Input
                                            name="rule-endProcess"
                                            bind:value={selectedRule.endProcess}
                                            validations={[
                                                RegexValidation(
                                                    /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
                                                    "Formato correto: 23:59:00"
                                                ),
                                            ]}
                                            label="Fim do Envio"
                                        />
                                    </div>

                                    <div class="row row-2">
                                        <Subtitle2 text="Processo periódico?" />
                                        <Switch
                                            bind:value={selectedRule.recursiveProcess}
                                        />
                                    </div>

                                    <div class="row row-1">
                                        <Subtitle2
                                            style="white-space: pre-wrap;"
                                            color={selectedRule.recursiveProcess
                                                ? "var(--color-level-8)"
                                                : "var(--color-level-5)"}
                                            text="Em processos periódicos o mesmo colaborador poderá ser checado várias vezes até acabar a faixa de envio ou até que um anomalia seja encontrada."
                                        />
                                    </div>

                                    <!-- Notifications -->
                                    <div class="row row-1">
                                        <SectionSubHeader
                                            color="var(--color-level-7)"
                                            icon={NotificationIcon}
                                            title="Notificações"
                                        />
                                    </div>
                                    <div class="row row-2">
                                        <Subtitle2 text="Envio por E-mail?" />
                                        <Switch
                                            bind:value={selectedRule
                                                .notification.email}
                                        />
                                    </div>
                                    <div class="row row-2">
                                        <Subtitle2
                                            text="Envio pelo WhatsApp?"
                                        />
                                        <Switch
                                            bind:value={selectedRule
                                                .notification.whatsapp}
                                        />
                                    </div>
                                    <div class="row row-2">
                                        <Subtitle2
                                            text="Envio por Notificação Desktop?"
                                        />
                                        <Switch
                                            bind:value={selectedRule
                                                .notification.desktop}
                                        />
                                    </div>
                                </div>

                                <div class="buttons">
                                    <Button
                                        text="cancelar"
                                        on:click={editCancel}
                                    />
                                    <Button
                                        disabled={!isFormValid}
                                        text="salvar"
                                        type="rised"
                                        on:click={editSave}
                                    />
                                </div>
                            </Form>
                        {/if}
                    </Sheet>
                </div>
            {/if}

            <!-- Time line -->
            <div class="rows timeline">
                <SectionSubHeader icon={RuleIcon} title="Linha do Tempo" />
                <Sheet style=" width: 100%; padding: 16px;">
                    {#if selectedRule && selectedJourney}
                        <TimeLine
                            bars={RuleUtils.getRuleBars(
                                selectedRule,
                                selectedJourney,
                                condittions
                            )}
                        />
                    {:else}
                        <div class="empty">
                            <EmptyIcon width={128} height={128} />
                            <Subtitle2
                                text="Selecione uma regra ou crie uma para visualizar a linha do tempo..."
                            />
                        </div>
                    {/if}
                </Sheet>
            </div>
        </div>
    </div>
</div>

<style>
    .rules-view {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        /* padding: 0 10%; */
        align-items: center;
        overflow: auto;
    }
    .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 16px;
    }
    .columns {
        display: flex;
        flex-direction: row;
        /* flex-wrap: wrap; */
        height: 100%;
        overflow: hidden;
    }

    .rows {
        display: flex;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        height: 100%;
    }

    .edit-content {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        padding: 16px;
    }

    .buttons {
        height: 48px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: var(--color-level-2);
    }

    .row {
        grid-template-columns: auto 1fr;
        display: grid;
        column-gap: 16px;
        margin-bottom: 8px;
    }

    .row-1 {
        grid-template-columns: auto;
    }
    .row-2 {
        grid-template-columns: 1fr 1fr;
    }
    .row-3 {
        grid-template-columns: 1fr 1fr 1fr;
    }
    .row-4 {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    .timeline {
        width: auto;
        flex-grow: 1;
    }

    .mr-16 {
        margin-right: 16px;
    }
    /* .ml-16 {
        margin-left: 16px;
    } */

    .list {
        width: 500px;
    }
    .list-info {
        width: 100%;
        justify-content: center;
    }
    .list-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        /* padding: 0 16px; */
        border-bottom: 1px solid var(--color-level-3);
    }

    .item-icon {
        height: 100%;
        padding: 0 16px;
        display: flex;
        align-items: center;
    }
    .item-icon:hover {
        background: var(--color-level-3);
    }

    /* TODO make this a component */
    .status {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 32px;
        align-items: center;
        padding: 0 16px;
    }

    .empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
</style>
